<template>
    <div>
        <div class="mb-3">
            <h3>Invoice</h3>
        </div>

        <div class="form-floating mb-3">
            <div :class="{ error: v$.customerName.$errors.length }">
                <label for="customerName">Customer Name <span class="required">*</span></label>
                <input type="text" class="form-control" id="customerName" placeholder="" v-model="store.customerName" />

                <div class="input-errors" v-if="v$.customerName.$errors.length > 0">
                    <div class="error-msg" v-for="error of v$.customerName.$errors" :key="error.$uid">{{ error.$message }}</div>
                </div>
            </div>
        </div>

        <div class="form-floating mb-3">
            <div :class="{ error: v$.customerNumber.$errors.length }">
                <label for="customerNumber">Customer Number <span class="required">*</span></label>
                <input type="text" class="form-control" id="customerNumber" placeholder="" v-model="store.customerNumber" />

                <div class="input-errors" v-if="v$.customerNumber.$errors.length > 0">
                    <div class="error-msg" v-for="error of v$.customerNumber.$errors" :key="error.$uid">{{ error.$message }}</div>
                </div>
            </div>
        </div>

        <div class="form-floating mb-3">
            <div :class="{ error: v$.emailAddress.$errors.length }">
                <label for="emailAddress">Email Address <span class="required">*</span></label>
                <input type="text" class="form-control" id="emailAddress" placeholder="" v-model="store.emailAddress" />

                <div class="input-errors" v-if="v$.emailAddress.$errors.length > 0">
                    <div class="error-msg" v-for="error of v$.emailAddress.$errors" :key="error.$uid">{{ error.$message }}</div>
                </div>
            </div>
        </div>

        <div class="mb-4 row">
            <div class="col-4">
                Invoice Number <span class="required">*</span>
            </div>
            <div class="col-4">
                Amount <span class="required">*</span>
            </div>
        </div>

        <div v-if="store.invoices.length > 0" v-for="(invoice, i) in store.invoices" class="row mb-3">
            <div class="col-4">
                <div>
                    <input v-model="invoice.number" class="form-control" :class="{ 'is-invalid': hasError(i, 'number') }" />
                    <div v-for="error in fieldErrors(i, 'number')" :key="error.$uid" class="error">{{ error.$message }}</div>
                </div>
            </div>
            <div class="col-4">
                <div>
                    <div class="input-group">
                        <span class="input-group-text">$</span>
                        <input type="number" v-model="invoice.amount" class="form-control" :class="{ 'is-invalid': hasError(i, 'amount') }" />
                    </div>
                    <div v-for="error in fieldErrors(i, 'amount')" :key="error.$uid" class="error">{{ error.$message }}</div>
                </div>
            </div>
            <div class="col-4">
                <button type="button" class="btn btn-danger" @click="removeInvoice(i)" v-if="store.invoices.length > 1">Remove</button>
            </div>
        </div>
        <div class="row">
            <div class="offset-8 col-4">
                <button type="button" class="btn btn-success" @click="addInvoice">Add Another Invoice</button>
            </div>
        </div>
        <div v-if="store.invoices.length > 0" class="row mb-3">
            <div class="col-4">
                <strong>
                    Total:
                </strong>
            </div>
            <div class="col-4">
                {{ formatCurrency(invoiceTotal) }}
            </div>
        </div>

        <!--<div class="row mb-3">
        <div class="col-4">
            <div class="form-floating">
                <input type="text" class="form-control" v-model="store.newInvoiceNumber" id="newInvoiceNumber" placeholder="" />
                <label form="newInvoiceNumber">Invoice Number <span class="required">*</span></label>
            </div>
        </div>
        <div class="col-4">
            <div class="form-floating">
                <input type="text" class="form-control" v-model="store.newInvoiceAmount" id="newInvoiceAmount" placeholder="" />
                <label for="newInvoiceAmount">Amount <span class="required">*</span></label>
            </div>
        </div>
    </div>-->

        <div class="text-center mb-3">
            <button type="button" class="btn btn-primary" @click="goToPage('PAYMENT')">Next</button>
        </div>

    </div>
</template>

<script setup>
    import { computed } from 'vue';
    import { useStore } from './store';
    import _ from 'lodash';
    import useVuelidate from '@vuelidate/core';
    import { required, email, minLength, helpers } from '@vuelidate/validators';

    const store = useStore();

    const rules = computed(() => ({
        customerName: { required },
        customerNumber: { required },
        emailAddress: { required, email },
        invoices: {
            minLength: minLength(1),
            $each: helpers.forEach({
                number: {
                    required: helpers.withMessage('Invoice Number is required', required)
                },
                amount: {
                    required: helpers.withMessage('Amount is required', required)
                }
            })
        }
    }));

    const v$ = useVuelidate(rules, store);

    const emit = defineEmits(['goToPage']);

    async function goToPage(page) {

        var isValid = await v$.value.$validate();

        if (isValid) {
            emit('goToPage', page);
        }
    }

    function hasError(index, fieldName) {
        return fieldErrors(index, fieldName).length > 0;
    }

    function fieldErrors(index, fieldName) {
        if (!v$.value.invoices.$dirty) {
            return [];
        }

        return v$.value.invoices.$each.$response.$errors[index]?.[fieldName] || [];
    }

    function addInvoice() {

        store.invoices.push({ 'number': ' ', 'amount': 0 });

    }

    function removeInvoice(index) {
        store.invoices.splice(index, 1);
    }

    function formatCurrency(amount) {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
        }).format(amount);
    }

    const invoiceTotal = computed(() => {
        var total = 0;

        _.forEach(store.invoices, invoice => {
            total += invoice.amount;
        });

        return total;
    });

</script>